import i18n from '@/i18n';

export default {
  change(locale) {
    i18n.locale = locale;
    localStorage.setItem('locale', locale);
  },
};
